<template>
    <div>
        <wizard-steps-list
            :activeStep="activeStep"
            @changeStep="goToCurStep"
            :steps="stepsTitles"
        />

        <div class="wizard-content" :class="{ 'is-panel-open': IS_PANEL_OPEN }">
            <component :is="steps[activeStep].component" :read="!orkInfo.editable" />

            <nav class="wizard-nav">
                <ul class="wizard-nav__inner">
                    <li class="wizard-nav__item wizard-nav__item_prev" v-if="activeStep > 1">
                        <button type="button" class="btn" @click="goToPreviousStep">Назад</button>
                    </li>
                    <li class="wizard-nav__item wizard-nav__item_next">
                        <button
                            v-if="activeStep === 5"
                            type="button"
                            class="btn btn_success"
                            @click="exportToExcel"
                        >
                            Экспортировать в Excel
                        </button>

                        <button
                            v-if="activeStep === 5 && orkInfo.status_id !== 4 && (orkInfo.status_id === 2 || orkInfo.status_id === 3 )"
                            type="button"
                            class="btn btn_primary"
                            @click="editOrk"
                        >
                            Редактировать
                        </button>

                        <template v-if="(this.user.role_id === 1 || this.user.role_id === 2 || this.user.role_id === 4) && (orkInfo.status_id !== 3 && orkInfo.status_id !== 4)">
                            <button
                                v-if="activeStep === 5 && orkInfo.status_id === 2"
                                type="button"
                                class="btn btn_danger"
                                @click="declineOrk"
                            >
                                Отклонить заявку
                            </button>

                            <button
                                v-if="activeStep === 5"
                                type="button"
                                class="btn btn_action"
                                @click="acceptOrk"
                            >
                                Утвердить заявку
                            </button>
                        </template>

                        <button
                            v-if="activeStep === 5 && (this.user.role_id === 3 || this.user.role_id === 5) || activeStep !== 5"
                            type="button"
                            class="btn btn_action"
                            v-html="steps[activeStep].nextStepLabel"
                            :disabled="(activeStep === 1 && !kinds.length) ||
                                (activeStep === 2 && !qualifications.length)
                            "
                            @click="goToNextStep()"
                        />
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import CompetencesStep from '@/components/WizardSteps/CompetencesStep';
import InterrelationsStep from '@/components/WizardSteps/InterrelationsStep';
import KindsStep from '@/components/WizardSteps/KindsStep';
import OrkStep from '@/components/WizardSteps/OrkStep';
import QualificationsStep from '@/components/WizardSteps/QualificationsStep';
import WizardStepsList from '@/components/WizardStepsList';

export default {
    components: {
        CompetencesStep,
        InterrelationsStep,
        KindsStep,
        OrkStep,
        QualificationsStep,
        WizardStepsList
    },
    data() {
        return {
            kindsLength: 0,
            steps: {
                1: {
                    id: 'areas',
                    component: 'kinds-step',
                    title: 'ОПД&nbsp;/ ВПД&nbsp;/ ПС',
                    nextStepLabel: 'Перейти к&nbsp;ПК из&nbsp;выбранных ВПД'
                },
                2: {
                    id: 'pk',
                    component: 'qualifications-step',
                    title: 'ПК',
                    nextStepLabel: 'Перейти к&nbsp;указанию общих компетенций'
                },
                3: {
                    id: 'competence',
                    component: 'competences-step',
                    title: 'Общие компетенции',
                    nextStepLabel: 'Перейти настройке взаимосвязей между&nbsp;ПК'
                },
                4: {
                    id: 'interrelation',
                    component: 'interrelations-step',
                    title: 'Взаимосвязи&nbsp;ПК',
                    nextStepLabel: 'Сформировать ОРК'
                },
                5: {
                    id: 'ork',
                    component: 'ork-step',
                    title: 'ОРК',
                    nextStepLabel: 'Отправить на&nbsp;утверждение'
                }
            }
        }
    },
    methods: {
        ...mapMutations('common', ['TOGGLE_PANEL']),
        ...mapActions('editor', ['LOAD_QUALIFICATIONS', 'SILENT_LOAD_QUALIFICATIONS_WITH_RELATIONS', 'LOAD_ORK_INFO']),
        ...mapActions('status', ['CHANGE_ORK_STATUS']),
        ...mapMutations('editor', ['NEXT_STEP', 'PREV_STEP', 'CUR_STEP' ,'GROUP_QUALIFICATIONS']),

        async goToPreviousStep() {
            this.resetPanels();
            if (this.activeStep === 3 && this.qualifications.find(el => el.work_functions === undefined)) this.SILENT_LOAD_QUALIFICATIONS_WITH_RELATIONS('workFunctions,programs')
            else if (this.activeStep === 4 && this.qualifications.find(el => el.hard_skills === undefined)) this.SILENT_LOAD_QUALIFICATIONS_WITH_RELATIONS('hardSkills,softSkills')
            else if (this.activeStep === 5 && this.qualifications.find(el => el.inherited === undefined)) this.SILENT_LOAD_QUALIFICATIONS_WITH_RELATIONS('trainings')

            setTimeout(() => {
                this.PREV_STEP()
            }, 0);
        },
        async goToNextStep() {
            this.resetPanels();
            if (this.activeStep === 1 && this.kindsLength !== this.kinds.length) {
                await this.LOAD_QUALIFICATIONS()
                await this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);
            }

            if (this.activeStep === 1 && this.qualifications.find(el => el.work_functions === undefined)) this.SILENT_LOAD_QUALIFICATIONS_WITH_RELATIONS('workFunctions,programs')
            else if (this.activeStep === 2 && this.qualifications.find(el => el.hard_skills === undefined)) this.SILENT_LOAD_QUALIFICATIONS_WITH_RELATIONS('hardSkills,softSkills')
            else if (this.activeStep === 3 && this.qualifications.find(el => el.inherited === undefined)) this.SILENT_LOAD_QUALIFICATIONS_WITH_RELATIONS('trainings')
            else if (this.activeStep === 5) {
                this.acceptOrk()
                return
            }

            this.kindsLength = this.kinds.length

            setTimeout(() => {
                this.NEXT_STEP()
            }, 0);
        },
        async goToCurStep(curPage) {
            this.resetPanels();
            if (this.activeStep === 1) {
                await this.LOAD_QUALIFICATIONS()
                await this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);
            }

            if (curPage === 2 && this.qualifications.find(el => el.work_functions === undefined)) this.SILENT_LOAD_QUALIFICATIONS_WITH_RELATIONS('workFunctions,programs')
            else if (curPage === 3 && this.qualifications.find(el => el.hard_skills === undefined)) this.SILENT_LOAD_QUALIFICATIONS_WITH_RELATIONS('hardSkills,softSkills')
            else if (curPage === 4 && this.qualifications.find(el => el.inherited === undefined)) this.SILENT_LOAD_QUALIFICATIONS_WITH_RELATIONS('trainings')

            this.kindsLength = this.kinds.length

            setTimeout(() => {
                this.CUR_STEP(curPage)
            }, 0);
        },
        
        async acceptOrk() {
            const curOrkId = this.$route.params.id
            let statusOrkId
            if (this.orkInfo.status_id === 1 || this.orkInfo.status_id === 2 || this.orkInfo.status_id === 5) {
                if (this.user.role_id === 3 || this.user.role_id === 5) statusOrkId = 2
                else statusOrkId = 3
            }
            else statusOrkId = 5
            const params = {
                orkId: curOrkId,
                statusId: statusOrkId
            }
            await this.CHANGE_ORK_STATUS(params)
            this.$router.push({ path: `/profile` }).catch(()=>{});
        },
        async editOrk() {
            const curOrkId = this.$route.params.id
            const params = {
                orkId: curOrkId,
                statusId: 5
            }
            await this.CHANGE_ORK_STATUS(params)
            this.LOAD_ORK_INFO()
        },
        async declineOrk() {
            const curOrkId = this.$route.params.id
            let statusOrkId = 4
            const params = {
                orkId: curOrkId,
                statusId: statusOrkId
            }
            await this.CHANGE_ORK_STATUS(params)
            this.$router.push({ path: `/profile` }).catch(()=>{});
        },
        resetPanels() {
          var keys = Object.keys(this.elPanels);
          keys.forEach(key => this.elPanels[key] = 0);
        },
        exportToExcel() {
            let uri = 'data:application/vnd.ms-excel;base64,'
            , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'
            , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
            , format = function(s, c) { 	    	 
                return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) 
            }
            , downloadURI = function(uri, name) {
                let link = document.createElement("a");
                link.download = name;
                link.href = uri;
                link.click();
            }
            , createTable = () => {
                let c, r, t, thead, tbody;
                t = document.createElement('table');

                let headersArr = [
                    'ОПД',
                    'Жизненный цикл',
                    'ВПД',
                    'ПС',
                    '1 уровень квалификации',
                    '2 уровень квалификации',
                    '3 уровень квалификации',
                    '4 уровень квалификации',
                    '5 уровень квалификации',
                    '6 уровень квалификации',
                    '7 уровень квалификации',
                    '8 уровень квалификации',
                    '9 уровень квалификации',
                ]
                let levelsQualification = [1, 2, 3, 4, 5, 6, 7, 8, 9]

                thead = document.createElement('thead');
                r = document.createElement('tr');
                headersArr.forEach((header) => {
                    c = document.createElement('th');
                    c.innerHTML = header
                    c.style.wordWrap = "break-word"
                    c.style.verticalAlign = "top"
                    c.style.fontWeight = "900"
                    c.style.textAlign = "left"
                    r.appendChild(c);
                })
                thead.appendChild(r);
                t.appendChild(thead);

                tbody = document.createElement('tbody');
                this.kinds.forEach((kind) => {
                    r = document.createElement('tr');

                    // ОПД
                    c = r.insertCell(0)
                    c.innerHTML = kind.area_id ? this.GET_AREA_BY_ID(kind.area_id).name : '-'
                    c.style.wordWrap = "break-word"
                    c.style.verticalAlign = "top"

                    // Жизненный цикл
                    c = r.insertCell(1)
                    c.innerHTML = kind.lifecycle_id ? this.GET_LIFECYCLE_BY_ID(kind.lifecycle_id).name : '-'
                    c.style.wordWrap = "break-word"
                    c.style.verticalAlign = "top"

                    // ВПД
                    c = r.insertCell(2)
                    c.innerHTML = kind.name
                    c.style.wordWrap = "break-word"
                    c.style.verticalAlign = "top"

                    // ПС
                    c = r.insertCell(3)
                    c.innerHTML = kind.standard_name
                    c.style.wordWrap = "break-word"
                    c.style.verticalAlign = "top"

                    levelsQualification.forEach(level => {
                        c = r.insertCell(3 + level)
                        c.style.wordWrap = "break-word"
                        c.style.verticalAlign = "top"

                        let tempAr = JSON.parse(JSON.stringify(this.qualifications))
                        let tempData = ''
                        tempAr = tempAr.filter(qualification => qualification.kind_id === kind.id && qualification.level === level)
                        tempAr.forEach((qualification, indexQualification) => {
                            if (indexQualification > 0) tempData += '<br/><br/>'
                            tempData += qualification.name
                        })
                        c.innerHTML = tempData
                    })

                     tbody.appendChild(r);
                })
                t.appendChild(tbody);

                return t
            }
            , name = `Сводная таблица по ОРК`
            , fileName = `${this.orkInfo.name}.xls`
            , table = '.el-table__header'

            if (!table.nodeType) table = createTable()
                let ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
            let resuri = uri + base64(format(template, ctx))
            downloadURI(resuri, fileName);
        }
    },
    computed: {
        ...mapGetters('common', ['IS_PANEL_OPEN']),
        ...mapGetters('editor', ['GET_AREA_BY_ID', 'GET_LIFECYCLE_BY_ID']),
        ...mapState('editor', ['activeStep', 'groupItemsBy', 'kinds', 'qualifications', 'orkInfo']),
        ...mapState('user', ['user']),
        ...mapState('common', ['panels']),

        elPanels() {
          return new Proxy(this.panels, {
            set: (target, prop, value) => {
              this.TOGGLE_PANEL({ [prop]: value });

              return true;
            },
          });
        },
        stepsTitles() {
            return Object.values(this.steps).map((item) => item.title);
        }
    }
}
</script>
